module.exports = __webpack_public_path__ + "static/bg_card-8499c0fa3b0c6d0d5be01e548dfafdf6.jpg";